import React, { useMemo } from 'react';
import { useTheme } from '../theme/ThemeContext';
import { getLayerSwitchConfirmTheme } from '../theme/themeStyles';

interface LayerSwitchConfirmDialogProps {
  isOpen: boolean;
  currentLayer: string;
  nextLayer: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function LayerSwitchConfirmDialog({
  isOpen,
  currentLayer,
  nextLayer,
  onConfirm,
  onCancel
}: LayerSwitchConfirmDialogProps) {
  const { isDark } = useTheme();
  const ls = useMemo(() => getLayerSwitchConfirmTheme(isDark), [isDark]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="layer-switch-confirm-heading"
    >
      <div className={ls.overlay} onClick={onCancel} aria-hidden />
      <div className="relative z-10 w-full max-w-md mx-4">
        <div className={ls.panel}>
        <div className="flex justify-center mb-4">
          <div className={ls.iconWrap}>
            <i className={ls.icon} aria-hidden />
          </div>
        </div>

        <h3 id="layer-switch-confirm-heading" className={ls.title}>
          Switch Layer Panel?
        </h3>

        <div className={ls.body}>
          <p>
            You are switching from <strong className={ls.emphasis}>{currentLayer}</strong> to{' '}
            <strong className={ls.emphasis}>{nextLayer}</strong>.
          </p>
          <p className={ls.warningBox}>
            <i className="ri-information-line mr-1" aria-hidden />
            All loaded data for <strong>{currentLayer}</strong> will be cleared.
          </p>
        </div>

        <div className="flex space-x-3">
          <button type="button" onClick={onCancel} className={ls.cancelBtn}>
            <i className="ri-close-line mr-1" aria-hidden />
            Cancel
          </button>
          <button type="button" onClick={onConfirm} className={ls.confirmBtn}>
            <i className="ri-check-line mr-1" aria-hidden />
            OK, Switch
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
